import React, { useEffect, useRef, useState } from "react";
import {
  Table,
  Input,
  Select,
  Button,
  Breadcrumb,
  message,
  Divider,
  Row,
  Col,
  Card,
  Grid,
  InputNumber,
  Drawer,
  notification,
  Spin,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  RightOutlined,
  EditOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import COLORS from "common/Colors";
import styled from "styled-components";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import { STATUS_CODE } from "common/Constants";
import { CALL_API } from "common/API";
import { useSelector } from "react-redux";
import {
  getClientid,
  getLocations,
  getMenuList,
  getUserInfo,
  getUserRoleId,
} from "redux/selectors";
import { concat, find, uniqBy } from "lodash";
import { isDateBetweenTwoDates } from "utils/Date";
import { ReactComponent as Trash } from "../../assets/trash.svg";
import holiday from "pages/holiday";
import moment from "moment";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import axios from "axios";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { AirplaneTicketOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
dayjs.extend(isSameOrBefore);

const { Option } = Select;
const { useBreakpoint } = Grid;

const AddLogWrap = styled.div`
  position: relative;
  height: calc(100vh - 150px);
  .ant-select-selector:hover {
    border-color: #ccc !important;
  }

  .nav_style {
    display: flex;
    align-items: center;
  }

  .product_log {
    cursor: pointer;
    font-size: 16px;
    font-weight: 400;
    color: #636980;
  }

  .adding_log {
    font-size: 16px;
    font-weight: 400;
  }
`;

const StyledTable = styled(Table)`
  table {
    min-width: 1000px;
    table-layout: fixed !important;
  }
  textarea.ant-input {
    border-radius: 10px;
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 10px;
  }

  .ant-table-content {
    overflow-x: auto;
  }

  .ant-table-cell {
    padding: 10px;
    height: 50px !important;
    border: none;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 3;
  }
  .ant-table-thead .ant-table-cell {
    border-right: none !important;
  }
  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-body
    > table
    > tbody
    > tr
    > td {
    border-right: none;
  }
  .ant-table tfoot > tr > td {
    border: none !important;
  }

  .ant-table-tbody > tr > td {
    border: none;
    border-bottom: 1px solid #f0f0f0 !important;
  }

  .action-icons {
    display: none;
  }
  .ant-table-tbody > tr:hover .action-icons {
    display: inline-flex;
    gap: 8px;
  }
`;

// 🔹 Generate week days dynamically from selecteddate
const getWeekDays = (selecteddate) => {
  const base = dayjs(selecteddate);
  const start = base.startOf("isoWeek"); // Monday

  return Array.from({ length: 7 }, (_, i) => {
    const d = start.add(i, "day");
    return {
      key: d.format("ddd").toLowerCase(), // mon, tue, wed...
      label: `${d.format("D")} - ${d.format("ddd")}`, // e.g. 22 - Mon
      date: d,
    };
  });
};

// 🔹 Format week range
const weekFormat = (value) => {
  const startOfWeek = dayjs(value).startOf("isoWeek").format("Do MMM YYYY");
  const endOfWeek = dayjs(value).endOf("isoWeek").format("Do MMM YYYY");
  return `${startOfWeek} - ${endOfWeek}`;
};

const AddEditProductLog = ({
  selecteddate,
  setIsAddEdit,
  logDetails,
  setLogDetails,
  isEdit = false,
  userid,
  isCurrentWeek,
  tabId,
  setTabId,
  details,
  setIsHRTab = () => {},
}) => {
  const { t } = useTranslation();
  const userInfo = useSelector(getUserInfo);
  const locationList = useSelector(getLocations);
  const screens = useBreakpoint();
  const weekDays = getWeekDays(selecteddate);
  const ClientId = useSelector(getClientid);
  const menuList = useSelector(getMenuList);

  const userRoleId = useSelector(getUserRoleId);
  const Menulist =
    menuList[userRoleId] || Object.values(menuList)[0] || menuList;

  const usertimezone = locationList.find(
    (item) => item.location_id === userInfo?.baseLocationId
  )?.usertimezone;

  const [dataSource, setDataSource] = useState(
    logDetails || [
      {
        key: Date.now(),
        product: "",
        module: "",
        notes: "",
        mon: 0,
        tue: 0,
        wed: 0,
        thu: 0,
        fri: 0,
        sat: 0,
        sun: 0,
      },
    ]
  );
  console.log("datasource--", dataSource);
  const [taskList, setTaskList] = useState([]);
  const [errors, setErrors] = useState({});
  const [projectList, setProjectList] = useState([]);
  const [editValues, setEditValues] = useState({});
  const [moduleList, setModuleList] = useState([]);
  const [editProductId, setEditProductId] = useState("");
  const [editModuleValues, setEditModuleValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDraftLoading, setIsDraftLoading] = useState(false);
  const [leaveList, setLeaveList] = useState([]);
  const [holidayList, setHolidayList] = useState([]);
  const [isAddProduct, setIsAddProduct] = useState(false);
  const [isAddModule, setIsAddModule] = useState(false);
  const [open, setOpen] = useState(false);
  const [editDrawerOpen, setEditDrawerOpen] = useState(false);
  const [newProductValue, setNewProductValue] = useState("");
  const [newModuleValue, setNewModuleValue] = useState("");
  const [modifyLoading, setModifyLoading] = useState(false);
  console.log("isAddProduct", isAddProduct);

  const filterModuleList = moduleList?.filter(
    (item) => item?.product_id === editProductId
  );

  const containerRef = useRef(null);
  const containerRefModule = useRef(null);

  const getTask = async () => {
    try {
      const resp = await axios.post(
        "https://nzthh0zab8.execute-api.ap-south-1.amazonaws.com/Prod/getalltask",
        {
          startdate: dayjs()
            .startOf("month")
            .subtract(2, "month")
            .format("YYYY-MM-DD"),
          enddate: dayjs().endOf("month").format("YYYY-MM-DD"),
        },
        { headers: {} }
      );
      if (resp?.data?.status) {
        setTaskList(resp?.data?.data);
      }
    } catch (err) {
      console.error("Error fetching task:", err);
    }
  };

  useEffect(() => {
    getTask();
  }, []);

  const submitProductLog = async (status) => {
    if (status === "submit") {
      setIsLoading(true);
    } else if (status === "draft") {
      setIsDraftLoading(true);
    }
    const { statusCode } = await CALL_API(
      details?.p_logid
        ? `productLogUpdate/${ClientId}/${details?.p_logid}`
        : `productLogCreate/${ClientId}`,
      details?.p_logid ? "patch" : "post",
      {
        userid: userid,
        week: `${dayjs(selecteddate).year()}-W${dayjs(selecteddate).isoWeek()}`,
        status: status,
        selected_date: selecteddate,
        productcount: uniqBy(
          dataSource?.map((item) => ({ value: item?.product })),
          "value"
        )?.length,
        daysworked: weekDays.filter((d) =>
          dataSource.some((row) => Number(row[d.key]) > 0)
        )?.length,
        submitedon: status === "submit" ? new Date() : new Date(),
        totalhours: dataSource?.reduce(
          (total, row) =>
            total +
            weekDays?.reduce((sum, d) => sum + (Number(row[d.key]) || 0), 0),
          0
        ),
        updatedon: new Date(),
        product_log: dataSource?.map((item) => ({
          ...item,
          moduleId: item?.module,
          productId: item?.product,
          modulename: moduleList?.find((val) => val?.module_id === item?.module)
            ? moduleList?.find((val) => val?.module_id === item?.module)
                ?.module_name
            : item?.modulename,
          productname: projectList?.find(
            (val) => val?.product_id === item?.product
          )
            ? projectList?.find((val) => val?.product_id === item?.product)
                ?.product_name
            : item?.productname,
        })),
      }
    );
    if (statusCode === STATUS_CODE.SUCCESS) {
      setIsLoading(false);
      setIsDraftLoading(false);
      setTabId(tabId);
      setIsAddEdit(false);
      setIsHRTab(false);

      if (status === "submit") {
        notification.success({ message: t("Log Submited Successfully") });
      } else if (status === "draft") {
        notification.success({ message: t("Draft Saved") });
      }
    } else {
      notification.error({ message: t("Something went wrong") });
      message?.error(t("Something went wrong. Please try again."));
    }
  };

  const Addproject = async () => {
    setModifyLoading(true);
    const { statusCode } = await CALL_API(
      `productLogCreate/${ClientId}`,
      "post",
      { method: "addnewproduct", product_name: newProductValue }
    );
    if (statusCode === STATUS_CODE.SUCCESS) {
      setIsAddProduct(false);
      notification.success({ message: t("Product Added Successfully") });
      getProjectList();
    } else {
      notification.error({ message: t("Something went wrong") });
      message.error(t("Something went wrong. Please try again."));
    }
    setModifyLoading(false);
  };

  const AddModule = async (productid) => {
    setModifyLoading(true);
    const { statusCode } = await CALL_API(
      `productLogCreate/${ClientId}`,
      "post",
      { module_name: newModuleValue, product_id: productid }
    );
    if (statusCode === STATUS_CODE.SUCCESS) {
      setIsAddModule(false);
      notification.success({ message: t("Module Added Successfully") });
      getModuleList();
    } else {
      notification.error({ message: t("Something went wrong") });
      message.error(t("Something went wrong. Please try again."));
    }
    setModifyLoading(false);
  };

  const getHolidayList = async () => {
    const startOfWeek = dayjs(selecteddate)
      .startOf("isoWeek")
      .format("YYYY-MM-DD");
    const endOfWeek = dayjs(selecteddate).endOf("isoWeek").format("YYYY-MM-DD");
    const response = await CALL_API(`holiday-list/${ClientId}`, "post", {
      start_date: startOfWeek,
      end_date: endOfWeek,
    });
    setHolidayList(
      response?.filter((item) =>
        item?.location_id?.includes(userInfo?.baseLocationId)
      )
    );
  };

  const getLeaveList = async () => {
    const startOfWeek = dayjs(selecteddate)
      .startOf("isoWeek")
      .format("YYYY-MM-DD");
    const endOfWeek = dayjs(selecteddate).endOf("isoWeek").format("YYYY-MM-DD");
    const { code, leaves } = await CALL_API(`leave-list/${ClientId}`, "post", {
      status_id: "4,5",
      department_id: [""],
      selected_role_id: "",
      start_date: startOfWeek,
      end_date: endOfWeek,
      show_my_team_leave: false,
    });
    if (code === STATUS_CODE.SUCCESS) {
      setLeaveList(leaves?.filter((val) => val?.userid === userid));
    }
  };

  const getProjectList = async () => {
    setLoading(true);
    const { statusCode, response } = await CALL_API(
      `projectListGet`,
      "get",
      {}
    );
    if (statusCode === STATUS_CODE.SUCCESS) {
      setProjectList(response);
      setLoading(false);
    }
  };

  const getModuleList = async () => {
    setLoading(true);
    const { statusCode, response } = await CALL_API(`moduleListGet`, "get", {});
    if (statusCode === STATUS_CODE.SUCCESS) {
      setModuleList(response);
      setLoading(false);
    }
  };

  const validateRows = () => {
    const newErrors = {};
    dataSource.forEach((row) => {
      const rowErrors = {};
      if (!row.product) rowErrors.product = true;
      if (!row.module) rowErrors.module = true;
      if (!row.notes) rowErrors.notes = true;
      if (row.notes && row.notes.length > 100) rowErrors.notes = true;
      weekDays.forEach((day) => {
        if (Number(row[day.key]) > 24) {
          if (!rowErrors.days) rowErrors.days = {};
          rowErrors.days[day.key] = true;
        }
      });
      if (Object.keys(rowErrors).length > 0) newErrors[row.key] = rowErrors;
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const tableRef = useRef(null);

  const calculateTotal = () => {
    const totals = {};
    weekDays?.forEach((day) => {
      totals[day.key] = dataSource?.reduce(
        (sum, row) => sum + (Number(row[day?.key]) || 0),
        0
      );
    });
    totals.total = Object.values(totals)?.reduce((a, b) => a + b, 0);
    return totals;
  };

  const handleChange = (value, key, column) => {
    const newData = [...dataSource];
    const row = newData.find((item) => item.key === key);
    row[column] = value;
    setDataSource(newData);
  };

  const handleAdd = () => {
    if (dataSource?.length === 100) {
      message.error(t("You can add maximum 100 rows only"));
      return;
    }
    setDataSource((prev) => {
      const newData = [
        ...prev,
        {
          key: Date.now(),
          product: "",
          module: "",
          notes: "",
          mon: 0,
          tue: 0,
          wed: 0,
          thu: 0,
          fri: 0,
          sat: 0,
          sun: 0,
        },
      ];
      setTimeout(() => {
        const tableBody = tableRef.current?.querySelector(".ant-table-body");
        if (tableBody) {
          tableBody.scrollTop = tableBody.scrollHeight;
        }
      }, 120);
      return newData;
    });
  };

  const handleDelete = (key) => {
    setDataSource(dataSource.filter((item) => item.key !== key));
  };

  const columns = [
    {
      title: t("Product"),
      dataIndex: "product",
      width: "200px",
      render: (value, record) =>
        isEdit ? (
          <Select
            style={{
              width: "100%",
              border: errors[record.key]?.product ? "1px solid red" : undefined,
              borderRadius: "10px",
            }}
            filterOption={(input, option) =>
              option?.label?.toLowerCase().includes(input.toLowerCase())
            }
            value={
              projectList?.find((item) => item?.product_id === value)
                ? value
                : record?.productname
            }
            options={projectList?.map((val) => ({
              label: val?.product_name,
              value: val?.product_id,
            }))}
            onChange={(val) => {
              handleChange(val, record.key, "product");
              if (errors[record.key]?.product) {
                setErrors((prev) => ({
                  ...prev,
                  [record.key]: { ...prev[record.key], product: false },
                }));
              }
            }}
            dropdownRender={(menu) => (
              <>
                <div style={{ position: "relative" }} ref={containerRef}>
                  <div style={{ overflowY: "auto" }}>{menu}</div>
                  <Divider style={{ margin: 0 }} />
                  {Menulist?.find(
                    (item) =>
                      item?.key === "hrproductlog" &&
                      (item?.permission.create ||
                        item?.permission.edit ||
                        item?.permission.delete)
                  ) && (
                    <div
                      style={{
                        position: "sticky",
                        bottom: 0,
                        background: "#fff",
                        textAlign: "center",
                        padding: "8px 0",
                        fontWeight: 500,
                        color: "#1D4174",
                        cursor: "pointer",
                      }}
                    >
                      {isAddProduct && (
                        <>
                          <div className="px-2">
                            <Input
                              onChange={(e) =>
                                setNewProductValue(e.target.value)
                              }
                            />
                          </div>
                          <div className="d-flex justify-content-end align-items-center p-2 gap-3">
                            <Button
                              type="link"
                              className="mx-0 px-0"
                              style={{ color: "#2D53DA" }}
                              onClick={() => {
                                setIsAddProduct(false);
                                setNewProductValue("");
                              }}
                            >
                              {t("Cancel")}
                            </Button>
                            <Button
                              type="link"
                              className="mx-0 px-1"
                              style={{ color: "#2D53DA" }}
                              onClick={Addproject}
                              loading={modifyLoading}
                              disabled={newProductValue === ""}
                            >
                              {t("Submit")}
                            </Button>
                          </div>
                        </>
                      )}
                      {!isAddProduct && (
                        <div className="d-flex justify-content-end align-items-center p-2 gap-3">
                          {Menulist?.find(
                            (item) =>
                              item?.key === "hrproductlog" &&
                              item?.permission.create
                          ) && (
                            <div onClick={() => setIsAddProduct(true)}>
                              <PlusOutlined style={{ marginRight: 6 }} />
                              {t("Add")}
                            </div>
                          )}
                          {Menulist?.find(
                            (item) =>
                              item?.key === "hrproductlog" &&
                              (item?.permission.edit || item?.permission.delete)
                          ) && (
                            <div onClick={() => setOpen(true)}>
                              <EditOutlined style={{ marginRight: 6 }} />
                              {t("Modify")}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </>
            )}
          />
        ) : (
          record?.productname ||
          projectList?.find((val) => val?.product_id === value)?.product_name ||
          "-"
        ),
    },
    {
      title: t("Module"),
      dataIndex: "module",
      width: "200px",
      render: (value, record) =>
        isEdit ? (
          <>
            <Select
              style={{
                width: "100%",
                border: errors[record.key]?.module
                  ? "1px solid red"
                  : undefined,
                borderRadius: "10px",
              }}
              value={
                moduleList?.find((item) => item?.module_id === value)
                  ? value
                  : record?.modulename
              }
              options={moduleList
                ?.filter((item) => item?.product_id === record?.product)
                .map((val) => ({
                  label: val?.module_name,
                  value: val?.module_id,
                }))}
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
              disabled={record?.product === ""}
              onChange={(val) => {
                handleChange(val, record.key, "module");
                if (errors[record.key]?.module) {
                  setErrors((prev) => ({
                    ...prev,
                    [record.key]: { ...prev[record.key], module: false },
                  }));
                }
              }}
              dropdownRender={(menu) => (
                <>
                  <div
                    style={{ position: "relative" }}
                    ref={containerRefModule}
                  >
                    <div style={{ overflowY: "auto" }}>{menu}</div>
                    <Divider style={{ margin: 0 }} />
                    {Menulist?.find(
                      (item) =>
                        item?.key === "hrproductlog" &&
                        (item?.permission.create ||
                          item?.permission.edit ||
                          item?.permission.delete)
                    ) && (
                      <div
                        style={{
                          position: "sticky",
                          bottom: 0,
                          background: "#fff",
                          textAlign: "center",
                          padding: "8px 0",
                          fontWeight: 500,
                          color: "#1D4174",
                          cursor: "pointer",
                        }}
                      >
                        {isAddModule && (
                          <>
                            <div className="px-2">
                              <Input
                                onChange={(e) =>
                                  setNewModuleValue(e.target.value)
                                }
                              />
                            </div>
                            <div className="d-flex justify-content-end align-items-center p-2 gap-3">
                              <Button
                                type="link"
                                className="mx-0 px-0"
                                style={{ color: "#2D53DA" }}
                                onClick={() => {
                                  setIsAddModule(false);
                                  setNewModuleValue("");
                                }}
                              >
                                {t("Cancel")}
                              </Button>
                              <Button
                                type="link"
                                className="mx-0 px-1"
                                style={{ color: "#2D53DA" }}
                                onClick={() => AddModule(record?.product)}
                                loading={modifyLoading}
                                disabled={newModuleValue === ""}
                              >
                                {t("Submit")}
                              </Button>
                            </div>
                          </>
                        )}
                        {!isAddModule && (
                          <div className="d-flex justify-content-end align-items-center p-2 gap-3">
                            {Menulist?.find(
                              (item) =>
                                item?.key === "hrproductlog" &&
                                item?.permission.create
                            ) && (
                              <div onClick={() => setIsAddModule(true)}>
                                <PlusOutlined style={{ marginRight: 6 }} />
                                {t("Add")}
                              </div>
                            )}
                            {Menulist?.find(
                              (item) =>
                                item?.key === "hrproductlog" &&
                                (item?.permission.edit ||
                                  item?.permission.delete)
                            ) && (
                              <div
                                onClick={() => {
                                  setEditProductId(record?.product);
                                  setEditDrawerOpen(true);
                                }}
                              >
                                <EditOutlined style={{ marginRight: 6 }} />
                                {t("Modify")}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </>
              )}
            />
            {console.log("record12", record)}
          </>
        ) : (
          record?.modulename ||
          moduleList?.find((val) => val?.module_id === value)?.module_name ||
          "-"
        ),
    },
    {
      title: t("Task ID"),
      dataIndex: "taskid",
      width: "200px",
      render: (value, record) =>
        isEdit ? (
          <Select
            showSearch
            style={{
              width: "100%",
              border: errors[record.key]?.taskid ? "1px solid red" : undefined,
              borderRadius: "10px",
            }}
            value={value}
            placeholder={t("Select Task")}
            optionFilterProp="label"
            filterOption={(input, option) =>
              option?.label?.toLowerCase()?.includes(input.toLowerCase())
            }
            options={taskList.map((val) => ({
              label: `${val?.trackingclientid}-${val?.trackingid}`,
              value: `${val?.trackingclientid}-${val?.trackingid}`,
            }))}
            disabled={record?.product === ""}
            onChange={(val) => {
              handleChange(val, record.key, "taskid");
              const selectedTask = taskList.find(
                (t) => `${t.trackingclientid}-${t.trackingid}` === val
              );
              if (selectedTask?.deadline) {
                handleChange(selectedTask.deadline, record.key, "deadline");
              }
            }}
          />
        ) : (
          value || "-"
        ),
    },
    {
      title: t("Expected Deadline"),
      dataIndex: "deadline",
      width: "200px",
      render: (value, record) =>
        isEdit ? (
          <Input.TextArea
            autoSize={{ minRows: 1, maxRows: 6 }}
            value={
              value && dayjs(value).isValid()
                ? dayjs(value).format("DD-MM-YYYY HH:mm A")
                : "-"
            }
            placeholder={t("Enter notes")}
            style={{ width: "100%" }}
            disabled
            maxLength={120}
            onChange={(e) =>
              handleChange(e.target.value, record.key, "deadline")
            }
          />
        ) : (
          dayjs(value)?.format("DD-MM-YYYY HH:mm A") || "-"
        ),
    },
    {
      title: t("Task Type"),
      dataIndex: "tasktype",
      width: "200px",
      render: (value, record) =>
        isEdit ? (
          <Select
            style={{
              width: "100%",
              border: errors[record.key]?.tasktype
                ? "1px solid red"
                : undefined,
              borderRadius: "10px",
            }}
            filterOption={(input, option) =>
              option?.label?.toLowerCase().includes(input.toLowerCase())
            }
            value={value}
            options={[t("Bug"), t("New Task")].map((val) => ({
              label: val,
              value: val,
            }))}
            onChange={(val) => handleChange(val, record.key, "tasktype")}
          />
        ) : (
          <div className="word-wrap">{value || "-"}</div>
        ),
    },
    {
      title: t("Notes"),
      dataIndex: "notes",
      width: "200px",
      borderRadius: "10px",
      render: (value, record) => {
        const isError = errors[record.key]?.notes;
        const isTooLong = value && value.length > 100;
        return isEdit ? (
          <>
            <Input.TextArea
              autoSize={{ minRows: 1, maxRows: 6 }}
              value={value}
              placeholder={t("Enter notes")}
              style={{
                width: "100%",
                borderColor: isError || isTooLong ? "red" : undefined,
              }}
              maxLength={120}
              onChange={(e) => {
                handleChange(e.target.value, record.key, "notes");
                if (errors[record.key]?.notes) {
                  setErrors((prev) => ({
                    ...prev,
                    [record.key]: { ...prev[record.key], notes: false },
                  }));
                }
              }}
            />
            <div style={{ color: isTooLong ? "red" : "#999", fontSize: 12 }}>
              {isTooLong && t("Maximum 100 characters")}
            </div>
          </>
        ) : (
          <div className="word-wrap">{value}</div>
        );
      },
    },
    ...weekDays.map((day) => ({
      title: day.label,
      dataIndex: day.key,
      width: "100px",
      align: "center",
      render: (value, record) => {
        const dayOfWeek = day?.date?.day();
        const isError = errors[record.key]?.days?.[day.key];
        const isTooLongTime = value && value > 24;
        const isValidDateValue = (val) => val && val !== "null" && val !== "";

        const HolidayMatch = holidayList?.find((holiday) => {
          return (
            day?.date.format("YYYY-MM-DD") >= holiday?.start_date &&
            day?.date.format("YYYY-MM-DD") <= holiday?.end_date
          );
        });

        const leaveMatch = leaveList?.find((leave) => {
          const startDate = isValidDateValue(leave.new_start_date)
            ? leave.new_start_date
            : leave.start_date;
          const endDate = isValidDateValue(leave.new_end_date)
            ? leave.new_end_date
            : leave.end_date;
          return (
            day?.date.format("YYYY-MM-DD") >= startDate &&
            day?.date.format("YYYY-MM-DD") <= endDate
          );
        });

        if (isEdit) {
          return (
            <Input
              type="number"
              min={0}
              max={2}
              value={value}
              onChange={(e) => {
                let val = e.target.value;
                if (/^\d*\.?\d{0,2}$/.test(val)) {
                  const numVal = Number(val);
                  if (numVal <= 24) {
                    handleChange(numVal, record.key, day.key);
                  }
                }
              }}
              style={{
                width: "100%",
                borderRadius: "10px",
                borderColor:
                  isError || isTooLongTime
                    ? "red"
                    : HolidayMatch && leaveMatch?.holiday !== "No"
                    ? "red"
                    : ((HolidayMatch &&
                        leaveMatch?.holiday === "Yes" &&
                        dayOfWeek !== 6 &&
                        dayOfWeek !== 0) ||
                        (dayOfWeek !== 6 && dayOfWeek !== 0) ||
                        (HolidayMatch &&
                          leaveMatch?.holiday === "Yes" &&
                          dayOfWeek === 6 &&
                          leaveMatch?.isSaturday === "Yes") ||
                        (dayOfWeek === 6 && leaveMatch?.isSaturday === "Yes") ||
                        (HolidayMatch &&
                          leaveMatch?.holiday === "Yes" &&
                          dayOfWeek === 0 &&
                          leaveMatch?.weekend === "Yes") ||
                        (dayOfWeek === 0 && leaveMatch?.weekend === "Yes")) &&
                      (leaveMatch?.having_cancel_request === "1" ||
                        leaveMatch?.status_id === "4")
                    ? "orange"
                    : ((HolidayMatch &&
                        leaveMatch?.holiday === "Yes" &&
                        dayOfWeek !== 6 &&
                        dayOfWeek !== 0) ||
                        (dayOfWeek !== 6 && dayOfWeek !== 0) ||
                        (HolidayMatch &&
                          leaveMatch?.holiday === "Yes" &&
                          dayOfWeek === 6 &&
                          leaveMatch?.isSaturday === "Yes") ||
                        (dayOfWeek === 6 && leaveMatch?.isSaturday === "Yes") ||
                        (HolidayMatch &&
                          leaveMatch?.holiday === "Yes" &&
                          dayOfWeek === 0 &&
                          leaveMatch?.weekend === "Yes") ||
                        (dayOfWeek === 0 && leaveMatch?.weekend === "Yes")) &&
                      leaveMatch?.status_id === "5"
                    ? "green"
                    : undefined,
              }}
            />
          );
        }

        if (leaveMatch || HolidayMatch) {
          let borderColor = "transparent";
          if (leaveMatch?.holiday !== "No" && HolidayMatch) {
            borderColor = "red";
          } else if (
            ((HolidayMatch &&
              leaveMatch?.holiday === "Yes" &&
              dayOfWeek !== 6 &&
              dayOfWeek !== 0) ||
              (dayOfWeek !== 6 && dayOfWeek !== 0) ||
              (HolidayMatch &&
                leaveMatch?.holiday === "Yes" &&
                dayOfWeek === 6 &&
                leaveMatch?.isSaturday === "Yes") ||
              (dayOfWeek === 6 && leaveMatch?.isSaturday === "Yes") ||
              (HolidayMatch &&
                leaveMatch?.holiday === "Yes" &&
                dayOfWeek === 0 &&
                leaveMatch?.weekend === "Yes") ||
              (dayOfWeek === 0 && leaveMatch?.weekend === "Yes")) &&
            (leaveMatch?.having_cancel_request === "1" ||
              leaveMatch?.status_id === "4")
          ) {
            borderColor = "orange";
          } else if (
            ((HolidayMatch &&
              leaveMatch?.holiday === "Yes" &&
              dayOfWeek !== 6 &&
              dayOfWeek !== 0) ||
              (dayOfWeek !== 6 && dayOfWeek !== 0) ||
              (HolidayMatch &&
                leaveMatch?.holiday === "Yes" &&
                dayOfWeek === 6 &&
                leaveMatch?.isSaturday === "Yes") ||
              (dayOfWeek === 6 && leaveMatch?.isSaturday === "Yes") ||
              (HolidayMatch &&
                leaveMatch?.holiday === "Yes" &&
                dayOfWeek === 0 &&
                leaveMatch?.weekend === "Yes") ||
              (dayOfWeek === 0 && leaveMatch?.weekend === "Yes")) &&
            leaveMatch?.status_id === "5"
          ) {
            borderColor = "green";
          }

          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <div
                style={{
                  width: 25,
                  height: 25,
                  borderRadius: "50%",
                  border: `1px solid ${borderColor}`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: 500,
                }}
              >
                {value}
              </div>
            </div>
          );
        }

        return value;
      },
    })),
    {
      title: t("Total"),
      dataIndex: "total",
      align: "center",
      width: "100px",
      render: (_, record) => {
        const rowTotal = weekDays?.reduce(
          (sum, d) => sum + (Number(record[d.key]) || 0),
          0
        );
        return <b>{rowTotal.toFixed(2)}</b>;
      },
    },
    {
      title: "",
      dataIndex: "action",
      align: "center",
      width: "50px",
      render: (_, record) => {
        return (
          isEdit && (
            <Trash
              style={{ cursor: "pointer" }}
              onClick={() => handleDelete(record.key)}
            />
          )
        );
      },
    },
  ];

  const totalRow = calculateTotal();

  const handleSubmit = () => {
    if (validateRows()) {
      setErrors({});
      message.success(t("Submitted successfully!"));
    }
  };

  useEffect(() => {
    getProjectList();
    getModuleList();
  }, []);

  useEffect(() => {
    getLeaveList();
    getHolidayList();
  }, [selecteddate]);

  const row = dataSource[0];
  const weekStart = weekDays[0].date.startOf("day");
  const weekEnd = weekDays[6].date.endOf("day");

  const leaveInWeek = leaveList
    ?.filter(
      (val) => val?.status_id === "5" && val?.having_cancel_request === "0"
    )
    ?.reduce((sum, d) => {
      const start = dayjs(
        d?.new_start_date &&
          d?.new_start_date !== "null" &&
          d?.new_start_date !== ""
          ? d.new_start_date
          : d.start_date
      );
      const end = dayjs(
        d?.new_end_date && d?.new_end_date !== "null" && d?.new_end_date !== ""
          ? d.new_end_date
          : d.end_date
      );

      const overlapStart = start.isAfter(weekStart) ? start : weekStart;
      const overlapEnd = end.isBefore(weekEnd) ? end : weekEnd;

      if (overlapStart.isAfter(overlapEnd)) return sum;

      const isHoliday = holidayList?.some((holiday) => {
        return (
          overlapStart.format("YYYY-MM-DD") >= holiday?.start_date &&
          overlapStart.format("YYYY-MM-DD") <= holiday?.end_date
        );
      });

      if (parseFloat(d?.number_of_days) === 0.5) {
        if (
          (isHoliday && d.holiday === "No") ||
          (d?.weekend === "No" && overlapStart.day() === 0) ||
          (d?.isSaturday === "No" && overlapStart.day() === 6)
        ) {
          return sum;
        }
        return sum + 0.5;
      }

      let days = 0;
      for (
        let m = overlapStart.clone();
        m?.isSameOrBefore(overlapEnd);
        m = m?.add(1, "day")
      ) {
        const dayOfWeek = m.day();
        const isHolidayDay = holidayList?.some((holiday) => {
          return (
            m.format("YYYY-MM-DD") >= holiday?.start_date &&
            m.format("YYYY-MM-DD") <= holiday?.end_date
          );
        });
        if (
          (isHolidayDay && d.holiday === "No") ||
          (dayOfWeek === 6 && d?.isSaturday === "No") ||
          (dayOfWeek === 0 && d?.weekend === "No")
        ) {
          continue;
        }
        days++;
      }
      return sum + days;
    }, 0);

  const data = [
    {
      label: t("Products"),
      value: uniqBy(
        dataSource?.map((item) => ({ value: item?.product })),
        "value"
      )?.length,
    },
    {
      label: t("Days Worked"),
      value: weekDays.filter((d) =>
        dataSource.some((row) => Number(row[d.key]) > 0)
      ).length,
    },
    {
      label: t("Leave"),
      value: leaveInWeek,
    },
    {
      label: t("Total Hours"),
      value: dataSource
        ?.reduce(
          (total, row) =>
            total +
            weekDays?.reduce((sum, d) => sum + (Number(row[d.key]) || 0), 0),
          0
        )
        .toFixed(2),
    },
  ];

  const footerStyle = {
    position: "absolute",
    bottom: -40,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "0px -20px",
  };

  const disableSubmit = dayjs(selecteddate)
    .tz(usertimezone)
    .startOf("isoWeek")
    .add(4, "day")
    .hour(17)
    .minute(30)
    .second(0)
    .isAfter(dayjs().tz(usertimezone));

  const handleInputChange = (e, id) => {
    const { value } = e.target;
    setEditValues((prev) => ({ ...prev, [id]: value }));
  };

  const handleInputModuleChange = (e, id) => {
    const { value } = e.target;
    setEditModuleValues((prev) => ({ ...prev, [id]: value }));
  };

  const handleEdit = async (id) => {
    setModifyLoading(true);
    const { statusCode } = await CALL_API(
      `productLogUpdate/null/null`,
      "patch",
      { method: "updateproduct", product_id: id, product_name: editValues[id] }
    );
    if (statusCode === STATUS_CODE.SUCCESS) {
      notification.success({ message: t("Product Updated Successfully") });
      setProjectList((prev) =>
        prev.map((item) =>
          item.product_id === id
            ? { ...item, product_name: editValues[id] || item.product_name }
            : item
        )
      );
    } else {
      notification.error({ message: t("Something went wrong") });
      message.error(t("Something went wrong. Please try again."));
    }
    setModifyLoading(false);
  };

  const handleModuleEdit = async (id) => {
    setModifyLoading(true);
    const { statusCode } = await CALL_API(
      `productLogUpdate/null/null`,
      "patch",
      {
        method: "updatemodule",
        module_id: id,
        product_id: editProductId,
        module_name: editModuleValues[id],
      }
    );
    if (statusCode === STATUS_CODE.SUCCESS) {
      notification.success({ message: t("Module Updated Successfully") });
      setModuleList((prev) =>
        prev.map((item) =>
          item.module_id === id
            ? { ...item, module_name: editModuleValues[id] || item.module_name }
            : item
        )
      );
    } else {
      notification.error({ message: t("Something went wrong") });
      message.error(t("Something went wrong. Please try again."));
    }
    setModifyLoading(false);
  };

  const handleDeletes = async (id, method) => {
    setModifyLoading(true);
    const { statusCode } = await CALL_API(
      `productmodule`,
      "delete",
      method === "deleteproduct"
        ? { method: method, product_id: id }
        : { method: method, module_id: id }
    );
    if (statusCode === STATUS_CODE.SUCCESS) {
      if (method === "deleteproduct") {
        notification.success({ message: t("Product Deleted Successfully") });
        setProjectList((prev) => prev.filter((item) => item.product_id !== id));
      } else if (method === "deletemodule") {
        notification.success({ message: t("Module Deleted Successfully") });
        setModuleList((prev) => prev.filter((item) => item.module_id !== id));
      }
    } else {
      notification.error({ message: t("Something went wrong") });
    }
    setModifyLoading(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsAddProduct(false);
        setNewProductValue("");
      }
      if (
        containerRefModule.current &&
        !containerRefModule.current.contains(event.target)
      ) {
        setIsAddModule(false);
        setNewModuleValue("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <AddLogWrap>
      <div className="nav_style">
        <p
          className="product_log"
          onClick={() => {
            setLogDetails({});
            setTabId(tabId);
            setIsAddEdit(false);
            setIsHRTab(false);
          }}
        >
          {t("Product Log")}
        </p>{" "}
        &nbsp;
        <RightOutlined style={{ marginBottom: "12px" }} />
        &nbsp;
        <p className="adding_log">{`${
          isEdit ? t("Adding Log") : t("Log Details")
        }`}</p>
      </div>
      {!isEdit && (
        <Card
          bordered
          style={{
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            margin: "20px 0px",
          }}
        >
          <Row align="middle" justify="center" wrap={!screens.md}>
            {data.map((item, index) => (
              <React.Fragment key={item.label}>
                <Col
                  xs={24}
                  md={6}
                  style={{ textAlign: "center", padding: "8px 0" }}
                >
                  <div style={{ color: "#8c8c8c", fontSize: 14 }}>
                    {item.label}
                  </div>
                  <div style={{ fontSize: 16, fontWeight: 600 }}>
                    {item.value}
                  </div>
                </Col>
                {index < data.length - 1 &&
                  (screens.md ? (
                    <Divider type="vertical" style={{ height: "40px" }} />
                  ) : (
                    <Divider style={{ margin: "8px 0" }} />
                  ))}
              </React.Fragment>
            ))}
          </Row>
        </Card>
      )}

      <div className="d-flex justify-content-between align-items-center">
        <b style={{ margin: "16px 0" }}>
          {t("Week")}: {weekFormat(selecteddate)}
        </b>
        <div className="d-flex gap-3 align-items-center">
          <div className="d-flex align-items-center gap-1">
            <div
              style={{
                width: "10px",
                height: "10px",
                border: "4px solid red",
                borderRadius: "50%",
              }}
            ></div>
            <div>{t("Holiday")}</div>
          </div>
          <div className="d-flex align-items-center gap-1">
            <div
              style={{
                width: "10px",
                height: "10px",
                border: "4px solid orange",
                borderRadius: "50%",
              }}
            ></div>
            <div>{t("Pending Leave")}</div>
          </div>
          <div className="d-flex align-items-center gap-1">
            <div
              style={{
                width: "10px",
                height: "10px",
                border: "4px solid green",
                borderRadius: "50%",
              }}
            ></div>
            <div>{t("Approved Leave")}</div>
          </div>
        </div>
      </div>

      <StyledTable
        ref={tableRef}
        className="mt-2 product-log-table"
        bordered
        pagination={false}
        dataSource={dataSource}
        columns={columns}
        sticky
        scroll={{ y: "calc(100vh - 380px)" }}
        summary={() => (
          <>
            <Table.Summary className="m-2">
              <Table.Summary.Row
                className="p-2"
                style={{ background: "#d3d9f1", border: "none" }}
              >
                <Table.Summary.Cell index={0}>
                  <b>{t("Total")}</b>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} />
                <Table.Summary.Cell index={2} />
                <Table.Summary.Cell index={3} />
                <Table.Summary.Cell index={4} />
                <Table.Summary.Cell index={5} />
                {weekDays.map((d, idx) => {
                  const dayOfWeek = d?.date?.day();
                  const isValidDateValue = (val) =>
                    val && val !== "null" && val !== "";

                  const HolidayMatch = holidayList?.find((holiday) => {
                    return (
                      d?.date.format("YYYY-MM-DD") >= holiday?.start_date &&
                      d?.date.format("YYYY-MM-DD") <= holiday?.end_date
                    );
                  });

                  const leaveMatch = leaveList?.find((leave) => {
                    const startDate = isValidDateValue(leave.new_start_date)
                      ? leave.new_start_date
                      : leave.start_date;
                    const endDate = isValidDateValue(leave.new_end_date)
                      ? leave.new_end_date
                      : leave.end_date;
                    return (
                      d?.date.format("YYYY-MM-DD") >= startDate &&
                      d?.date.format("YYYY-MM-DD") <= endDate
                    );
                  });

                  let borderColor = "transparent";
                  if (leaveMatch?.holiday !== "No" && HolidayMatch) {
                    borderColor = "red";
                  } else if (
                    ((HolidayMatch &&
                      leaveMatch?.holiday === "Yes" &&
                      dayOfWeek !== 6 &&
                      dayOfWeek !== 0) ||
                      (dayOfWeek !== 6 && dayOfWeek !== 0) ||
                      (HolidayMatch &&
                        leaveMatch?.holiday === "Yes" &&
                        dayOfWeek === 6 &&
                        leaveMatch?.isSaturday === "Yes") ||
                      (dayOfWeek === 6 && leaveMatch?.isSaturday === "Yes") ||
                      (HolidayMatch &&
                        leaveMatch?.holiday === "Yes" &&
                        dayOfWeek === 0 &&
                        leaveMatch?.weekend === "Yes") ||
                      (dayOfWeek === 0 && leaveMatch?.weekend === "Yes")) &&
                    (leaveMatch?.having_cancel_request === "1" ||
                      leaveMatch?.status_id === "4")
                  ) {
                    borderColor = "orange";
                  } else if (
                    ((HolidayMatch &&
                      leaveMatch?.holiday === "Yes" &&
                      dayOfWeek !== 6 &&
                      dayOfWeek !== 0) ||
                      (dayOfWeek !== 6 && dayOfWeek !== 0) ||
                      (HolidayMatch &&
                        leaveMatch?.holiday === "Yes" &&
                        dayOfWeek === 6 &&
                        leaveMatch?.isSaturday === "Yes") ||
                      (dayOfWeek === 6 && leaveMatch?.isSaturday === "Yes") ||
                      (HolidayMatch &&
                        leaveMatch?.holiday === "Yes" &&
                        dayOfWeek === 0 &&
                        leaveMatch?.weekend === "Yes") ||
                      (dayOfWeek === 0 && leaveMatch?.weekend === "Yes")) &&
                    leaveMatch?.status_id === "5"
                  ) {
                    borderColor = "green";
                  }

                  return (
                    <Table.Summary.Cell
                      index={5 + idx}
                      key={d.key}
                      align="center"
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <div
                          style={{
                            width: 45,
                            height: 45,
                            borderRadius: "50%",
                            border: `1px solid ${borderColor}`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: 500,
                          }}
                        >
                          {Number(totalRow[d.key] || 0)
                            .toFixed(2)
                            .replace(/\.00$/, "")
                            .replace(/(\.\d)0$/, "$1")}
                        </div>
                      </div>
                    </Table.Summary.Cell>
                  );
                })}
                <Table.Summary.Cell index={3 + weekDays.length} align="center">
                  <b>{Number(totalRow.total || 0).toFixed(2)}</b>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4 + weekDays.length} />
              </Table.Summary.Row>
            </Table.Summary>
          </>
        )}
        footer={
          !isEdit
            ? null
            : () => (
                <div style={{ textAlign: "left" }}>
                  <Button
                    type="link"
                    className="d-flex align-items-center"
                    style={{ color: "#2D53DA" }}
                    icon={<PlusOutlined className="m-0 p-0" />}
                    onClick={handleAdd}
                  >
                    {t("Add another")}
                  </Button>
                </div>
              )
        }
      />
      {isEdit && (
        <div style={footerStyle}>
          <ButtonOutlined
            onClick={() => {
              setLogDetails({});
              setTabId(tabId);
              setIsAddEdit(false);
              setIsHRTab(false);
            }}
          >
            {t("Cancel")}
          </ButtonOutlined>
          <ButtonOutlined
            type="primary"
            onClick={() => submitProductLog("draft")}
            loading={isDraftLoading}
            disabled={dataSource?.length === 0}
          >
            {t("Save as Draft")}
          </ButtonOutlined>
          <ButtonFilled
            type="primary"
            htmlType="submit"
            onClick={() => {
              if (validateRows()) {
                submitProductLog("submit");
              }
            }}
            loading={isLoading}
          >
            {t("Submit")}
          </ButtonFilled>
        </div>
      )}
      <Drawer
        title={t("Modify Products")}
        closable
        onClose={() => setOpen(false)}
        open={open}
      >
        <Spin spinning={modifyLoading}>
          {projectList?.length > 0 ? (
            projectList.map((item) => {
              const currentValue =
                editValues[item.product_id] ?? item.product_name;
              const isChanged = currentValue !== item.product_name;
              return (
                <div
                  key={item.product_id}
                  className="d-flex gap-2 pb-2 align-items-center"
                >
                  <Input
                    value={currentValue}
                    onChange={(e) => handleInputChange(e, item.product_id)}
                    disabled={
                      !Menulist?.find(
                        (item) =>
                          item?.key === "hrproductlog" && item?.permission.edit
                      )
                    }
                  />
                  {isChanged && (
                    <CheckCircleOutlined
                      onClick={() => handleEdit(item.product_id)}
                      style={{
                        color: "#1D4174",
                        fontSize: 16,
                        cursor: "pointer",
                      }}
                    />
                  )}
                  {Menulist?.find(
                    (item) =>
                      item?.key === "hrproductlog" && item?.permission.delete
                  ) && (
                    <DeleteOutlined
                      onClick={() =>
                        handleDeletes(item.product_id, "deleteproduct")
                      }
                      style={{ color: "red", fontSize: 16, cursor: "pointer" }}
                    />
                  )}
                </div>
              );
            })
          ) : (
            <div style={{ textAlign: "center", color: "#999" }}>
              {t("No products found")}
            </div>
          )}
        </Spin>
      </Drawer>

      <Drawer
        title={t("Modify Modules")}
        closable
        onClose={() => setEditDrawerOpen(false)}
        open={editDrawerOpen}
      >
        <Spin spinning={modifyLoading}>
          {filterModuleList?.length > 0 ? (
            filterModuleList.map((item) => {
              const currentValue =
                editModuleValues[item.module_id] ?? item.module_name;
              const isChanged = currentValue !== item.module_name;
              return (
                <div
                  key={item.module_id}
                  className="d-flex gap-2 pb-2 align-items-center"
                >
                  <Input
                    value={currentValue}
                    onChange={(e) => handleInputModuleChange(e, item.module_id)}
                    disabled={
                      !Menulist?.find(
                        (item) =>
                          item?.key === "hrproductlog" && item?.permission.edit
                      )
                    }
                  />
                  {isChanged && (
                    <CheckCircleOutlined
                      onClick={() => handleModuleEdit(item.module_id)}
                      style={{
                        color: "#1D4174",
                        fontSize: 16,
                        cursor: "pointer",
                      }}
                    />
                  )}
                  {Menulist?.find(
                    (item) =>
                      item?.key === "hrproductlog" && item?.permission.delete
                  ) && (
                    <DeleteOutlined
                      onClick={() =>
                        handleDeletes(item.module_id, "deletemodule")
                      }
                      style={{ color: "red", fontSize: 16, cursor: "pointer" }}
                    />
                  )}
                </div>
              );
            })
          ) : (
            <div style={{ textAlign: "center", color: "#999" }}>
              {t("No Modules found")}
            </div>
          )}
        </Spin>
      </Drawer>
    </AddLogWrap>
  );
};

export default AddEditProductLog;
